export default __webpack_public_path__ + "static/media/img2.012601de.jpg";